export const PresetWorkflowData = {
    "name": "",
    "assessmentTypesString": "",
    "assessmentTypes":[],
    "kinetisensePresetWorkflow": false,
    "isDeleted":false,
    "organizationId": null,
    "groupName": "",
    "associatedCFTemplate": null,
    "isFpmEnabled": false,
    "id": null,
    "version": "",
    "createdAt": "",
    "updatedAt": "",
    "deleted": false
};